import { render, staticRenderFns } from "./ReportSinisterModal.vue?vue&type=template&id=4955341d&scoped=true&"
import script from "./ReportSinisterModal.vue?vue&type=script&lang=js&"
export * from "./ReportSinisterModal.vue?vue&type=script&lang=js&"
import style0 from "./ReportSinisterModal.vue?vue&type=style&index=0&id=4955341d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4955341d",
  null
  
)

export default component.exports